import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UrlParserTextArea } from 'shared/components/ui/url-parser';
import { useDelayedCallback } from 'shared/hooks/use-delayed-callback';

import * as Styled from './life-area-summary-header.style';

export type LifeAreaDescriptionProps = {
  value?: string | null;
  onChange?: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
  onClick?: () => void;
};

export const LifeAreaDescription: React.FC<LifeAreaDescriptionProps> = ({
  value,
  onChange,
  disabled,
  placeholder,
  onClick,
}) => {
  const { t } = useTranslation();
  const focussedRef = useRef(false);
  const [tempDescription, setTempDescription] = useState(value ?? '');
  const [delayedOnChange, killOnChangeDelay] = useDelayedCallback(
    (value: string) => onChange?.(value),
    500,
  );

  const _onBlur = () => {
    killOnChangeDelay();

    if (disabled || tempDescription === value || !onChange) {
      return;
    }

    onChange(tempDescription);
  };

  const _onChange = (value: string) => {
    if (disabled || !onChange) {
      return;
    }

    setTempDescription(value);
    delayedOnChange(value);
  };

  useEffect(() => {
    if (!focussedRef.current) {
      setTempDescription(value ?? '');
    }
  }, [value]);

  return (
    <Styled.DescriptionContainer onClick={onClick}>
      <UrlParserTextArea
        value={tempDescription}
        placeholder={
          placeholder ??
          t('pages.life-area-detail.summary.description.placeholder')
        }
        onChange={_onChange}
        onBlur={_onBlur}
        disabled={disabled}
        readOnly={!onChange}
        linkComponent={Styled.Anchor}
        variant="overline"
        inheritTypography
        respectNewLines
      />
    </Styled.DescriptionContainer>
  );
};
